const baseUrl = '/api/v2/common';
export default ($axios) => {
    return {
        generateXml(params) {
            return $axios.get(`${baseUrl}/xml/generate`, { params })
        },
    };
};
